<!-- TIMELINE option -->
<div [routerLink]="['/reservations/reserve']" class="option timeline">
  <div class="image">
    <div>
      <span></span>
      <span></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
    </div>
    <div>
      <span></span>
      <span></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
    </div>
    <div>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span class="occupied"></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div class="option-name">
    <h3>
      {{ translation.menu.timeline | transloco }}
      <cue-icon [icon]="cueArrowDown" />
    </h3>
    <p>
      {{ translation.reservationOption.timelineDescription | transloco }}
    </p>
  </div>
</div>

<hr />

<div [routerLink]="['/floorplans']" class="option floorplan">
  <div class="image">
    <img class="dialog-image" src="assets/images/floorplan-option.png" />
  </div>
  <div class="option-name">
    <h3>
      {{ translation.menu.floorplans | transloco }}
      <cue-icon [icon]="cueArrowDown" />
    </h3>
    <p>
      {{ translation.reservationOption.floorplansDescription | transloco }}
    </p>
  </div>
</div>

@if (useNewReservationUI()) {
  <hr />

  <div class="option dialog" (click)="openNewReservationDialog()">
    <div class="image">
      <img class="dialog-image dialog-image--idle" src="assets/images/reservation-dialog-option.svg" />
      <img class="dialog-image dialog-image--active" src="assets/images/reservation-dialog-option-color.svg" />
    </div>
    <div class="option-name">
      <h3>
        {{ translation.reservationOption.dialogTitle | transloco }}
        <cue-icon [icon]="cueArrowDown" />
      </h3>
      <p>
        {{ translation.reservationOption.dialogDescription | transloco }}
      </p>
    </div>
  </div>
}
